module.exports = __webpack_public_path__ + "img/pc_banner_gradient.c61f6083.jpg";